import { render, staticRenderFns } from "./CardWithHeader.vue?vue&type=template&id=633eb092&scoped=true&"
import script from "./CardWithHeader.vue?vue&type=script&lang=js&"
export * from "./CardWithHeader.vue?vue&type=script&lang=js&"
import style0 from "./CardWithHeader.vue?vue&type=style&index=0&id=633eb092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633eb092",
  null
  
)

export default component.exports